import { Component, OnInit, Input, Output, EventEmitter, SkipSelf } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-inputText',
  templateUrl: './inputText.component.html',
  styleUrls: ['./inputText.component.css'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class InputTextComponent implements OnInit {
  showErrorMessage=false;
  errorMesage:any;
  options: any[] = [];
  @Input() label: String;
  @Input() apiService: any;
  @Input() maxlength:any;
  @Input() minlength:any;
  @Input() pattern:any;
  @Input() name:string = '';
  @Input() required:boolean = false;
  @Input() type:any;
  @Input() model:any;
  @Input() autocomplete:any = "off";
  @Input() showError(bool){
    this.showErrorMessage=bool;
  };
  @Output() onModelChange = new EventEmitter<number>();
  formName: string = '';
  labelName :String='';
  requiredProperty:boolean=false;
  constructor() { }
  ngOnInit() {
    this.formName = this.name ;
    this.requiredProperty= this.required;
    this.labelName= this.requiredProperty ? this.label+'*': this.label;
  }
  modelChange($event) {
    this.onModelChange.emit($event);
  }
}